import { useMemo } from "react";
import { IconButton, InputAdornment } from "@mui/material";
import { Close } from "@mui/icons-material";

export const useTextFieldClearableSupport = (
  notEmpty: boolean,
  clearValue: () => void
) =>
  useMemo(() => {
    const handleClear = (event: React.MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation();
      clearValue();
    };

    return {
      slotProps: {
        input: {
          endAdornment: notEmpty ? (
            <InputAdornment position="end">
              <IconButton
                className="clearButton"
                onClick={handleClear}
                edge="end"
              >
                <Close fontSize="small" />
              </IconButton>
            </InputAdornment>
          ) : undefined,
        },
      },
      sx: {
        ".clearButton": {
          visibility: "hidden",
        },
        "&:hover .clearButton": {
          visibility: "visible",
        },
      },
    };
  }, [notEmpty, clearValue]);
